import { useState } from 'react';
import { faqItems } from '@/mocks/vigorbuy';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="py-20 md:py-28 bg-background-50">
      <div className="max-w-[800px] mx-auto px-6 md:px-10">
        <div className="text-center mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold uppercase tracking-wider mb-4">
            FAQ
          </span>
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-foreground-950 tracking-tight">
            Frequently Asked Questions
          </h2>
          <p className="mt-4 text-base text-foreground-600">
            Everything you need to know about the VigorBuy Spreadsheet
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-lg overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer hover:bg-background-200/50 transition-colors duration-200"
              >
                <span className="text-sm font-semibold text-foreground-900 pr-4">
                  {item.question}
                </span>
                <div
                  className={`w-6 h-6 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${
                    openIndex === idx ? 'rotate-45' : ''
                  }`}
                >
                  <i className="ri-add-line text-primary-600 text-xs"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === idx ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-6 pb-5">
                  <p
                    className="text-sm text-foreground-600 leading-relaxed"
                    dangerouslySetInnerHTML={{ __html: item.answer }}
                  ></p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}